import Vue from "vue";
import axios from "axios";
import { Dropdown } from "bootstrap";
import Swiper from "swiper/swiper-bundle";

import Modal from "../vue/components/Modal.vue";
import Multiselect from "../vue/components/MultiSelect.vue";
const { body, documentElement } = document;

export default {
  init() {

    document.querySelector(".hamburger").addEventListener("click", (e) => {
      e.preventDefault();
      documentElement.classList.toggle("open-menu");
    });

    for (const item of document.querySelectorAll(".property-swiper")) {
      new Swiper(item, {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 1,
        navigation: {
          nextEl: item.querySelector(".property-button-next"),
          prevEl: item.querySelector(".property-button-prev"),
          clickable: true,
        },
        pagination: {
          el: ".property-pagination",
        },
        breakpoints: {
          768: {
            spaceBetween: 48,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }

    for (const item of document.querySelectorAll(".articles-swiper")) {
      new Swiper(item, {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 1,
        pagination: {
          el: ".articles-pagination",
        },
        breakpoints: {
          768: {
            spaceBetween: 48,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }

    for (const item of document.querySelectorAll(".home-property-swiper")) {
      new Swiper(item, {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 1,
        navigation: {
          nextEl: item.querySelector(".home-property-button-next"),
          prevEl: item.querySelector(".home-property-button-prev"),
          clickable: true,
        },
        pagination: {
          el: ".home-property-pagination",

        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1200: {
            slidesPerView: 3,
            grid: {
              rows: 2,
              fill: 'row',
            },
            spaceBetween: 0,
          },
        },
      });
    }

    const setCookie = function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    };

    const getCookie = function getCookie(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return c.substring(nameEQ.length, c.length);
      }
      return null;
    };

    new Vue({
      el: ".consent-popup",
      data() {
        return {
          showPopup: true,
          acceptText: LTM.lang === "th" ? "ยอมรับทั้งหมด" : "Accept all",
          notAcceptText: LTM.lang === "th" ? "ไม่ยอมรับ" : "Not Accept",
          message:
            LTM.lang === "th"
              ? `เว็บไซต์นี้มีการใช้คุกกี้เพื่อให้แน่ใจว่าเราได้มอบประสบการณ์ที่ดีที่สุดในการใช้งานเว็บไซต์ให้กับคุณ หากคุณใช้เว็บไซต์ต่อหรือปิดหน้าต่างนี้ลง เราจะถือว่าคุณยอมรับเงื่อนไขในการใช้งานคุกกี้และ <a href="https://landthaimarket.com/privacy-policy">นโยบายความเป็นส่วนตัว</a>`
              : `This website uses cookies to enhance your experience of our site. By continuing or close this tab, we assume that you accept such use. <a href="https://landthaimarket.com/en/privacy-policy/">Privacy Policy</a>`,
        };
      },
      mounted() {
        if (getCookie("consent_accept")) this.showPopup = false;

        setTimeout(() => {
          if (this.$refs.consentPopup)
            this.$refs.consentPopup.classList.add("is-active");
        }, 400);
      },

      methods: {
        accept() {
          this.showPopup = false;
          setCookie("consent_accept", true, 100);
        },
      },
    });

    for (const propertyImage of document.querySelectorAll(".property-image")) {
      propertyImage.addEventListener("contextmenu", (event) =>
        event.preventDefault()
      );
    }

  },
  finalize() {

    for (const form of document.querySelectorAll(".post-property-form")) {
      new Vue({
        components: { Modal },
        el: form,

        data() {
          return {
            isLoading: false,
            consentModal: false,
            thankModal: false,
            postPropertyRecaptcha: false,
            confirmDisabled: true,
            form: {
              property_type: null,
              property_for: null,
            },
            intervalId: null
          };
        },

        watch: {
          consentModal(newVal) {
            if (newVal) {
              this.startInterval();
            } else {
              this.stopInterval();
            }
          }
        },

        methods: {
          acceptConsent() {
            this.postPropertyRecaptcha = false
            if (grecaptcha.getResponse(postPropertyRecaptcha).length !== 0) {
              this.consentModal = false
              this.submit();
            } else {
              this.postPropertyRecaptcha = true
            }
          },

          submit() {
            this.isLoading = true;
            this.form.grecaptcha = grecaptcha.getResponse(postPropertyRecaptcha);
            axios
              .post(`${LTM.api.url}v1/consignment`, this.form)
              .then(({ data }) => {
                this.thankModal = true;
                this.form = {
                  property_type: null,
                  property_for: null,
                };
              })
              .catch((error) => { })
              .then(() => {
                this.isLoading = false;
                this.confirmDisabled = true
                grecaptcha.reset(postPropertyRecaptcha)
              });
          },

          startInterval() {
            this.intervalId = setInterval(this.checkValue, 2000);
          },

          stopInterval() {
            clearInterval(this.intervalId);
          },

          checkValue() {
            if (grecaptcha.getResponse(postPropertyRecaptcha)) {
              this.confirmDisabled = false
              this.stopInterval()
            }
          }

        },
        beforeDestroy() {
          this.stopInterval();
        }

      });
    }

    for (const form of document.querySelectorAll(".investor-register-form")) {

      new Vue({
        components: { Modal, Multiselect },
        el: form,
        data() {
          return {
            isLoading: false,
            thankModal: false,
            registerRecaptcha: false,
            placeholder: 'เลือก',
            clear: false,
            data: [
              { id: "กรุงเทพฯ ปริมณฑล", label: "กรุงเทพฯ ปริมณฑล" },
              { id: "เชียงใหม่", label: "เชียงใหม่" },
              { id: "ภูเก็ต", label: "ภูเก็ต" },
              { id: "ชลบุรี", label: "ชลบุรี" },
            ],
            selected: [],
            types: [],
            form: {
              property_type: [],
              area: [],
              budget: " ",
            },
          };
        },

        methods: {
          acceptConsentRegister() {
            this.registerRecaptcha = false
            if (grecaptcha.getResponse(investorRegisterRecaptcha).length !== 0) {
              this.submit();
            }
            else {
              this.registerRecaptcha = true
            }
          },

          submit() {
            this.isLoading = true;
            this.form.property_type = this.types.toLocaleString()
            this.form.area = this.selected.toLocaleString()
            this.form.grecaptcha = grecaptcha.getResponse(investorRegisterRecaptcha);
            axios
              .post(`${LTM.api.url}v1/buy-property`, this.form)
              .then(({ data }) => {
                this.clear = true
                this.thankModal = true;
                this.form = {
                  property_type: [], area: [],
                  budget: " ",
                };
                this.types = []
                this.selected = []
                this.isLoading = false;
                this.clear = false
              })
              .catch((error) => { })
              .then(() => {
                this.isLoading = false;
                this.clear = true
                grecaptcha.reset(investorRegisterRecaptcha)
              });
          },
        },
      });
    }

    const dropdownElementList = [].slice.call(
      document.querySelectorAll(".dropdown-toggle")
    );
    dropdownElementList.map(function (dropdownToggleEl) {
      return new Dropdown(dropdownToggleEl);
    });

    window.addEventListener("scroll", () => {
      if (body.getBoundingClientRect().top < 0) {
        body.classList.add("header-sticky");
      } else {
        body.classList.remove("header-sticky");
      }
    });

    // Hide on scroll functionality
    let lastScrollTop = 0;
    const navbar = document.querySelector(".navbar");

    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY;
      if ((lastScrollTop === 0 && scrollTop > 200) || (lastScrollTop >= 200 && scrollTop > lastScrollTop)) {
        navbar.classList.add("navbar-hide");
      } else {
        navbar.classList.remove("navbar-hide");
      }
      lastScrollTop = scrollTop;
    });
  },
};
